var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPub1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 23,
    viewBox: "0 0 27 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.81351 6.89336H19.1253C19.7463 6.89336 20.2503 6.37795 20.2503 5.74289C20.2503 5.10782 19.7463 4.59241 19.1253 4.59241H10.8682L14.963 1.38489C17.196 -0.566314 20.518 -0.442063 22.6059 1.67136L25.3339 4.43135C26.397 5.51509 26.9955 6.9854 27 8.52013V17.2476C27 20.4241 24.4812 23 21.3752 23H16.0643C13.3836 23 11.0752 21.0649 10.5487 18.3762L9.20324 12.6457H2.81238C1.25882 12.6457 0 11.3584 0 9.76955C0 8.18074 1.25995 6.89336 2.81351 6.89336Z",
    fill: "#A7A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPub1);
export default __webpack_public_path__ + "static/media/pub-1.471a73f72aba294c8089bdefdab8547e.svg";
export { ForwardRef as ReactComponent };